// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconCallOutLarge: React.FC<{}> = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="995"
            height="358"
            viewBox="0 0 995 358"
        >
            <defs>
                <pattern id="c" width="100%" height="100%" x="0%" patternUnits="objectBoundingBox">
                    <use xlinkHref="#a" transform="scale(4.75)" />
                </pattern>
                <image
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAAAs0lEQVRoBe2YQQrDMAwE4/7J/3+AH9XS4x7FkG0Dk5vAkuIZC4zX3vt9Db5zzhosv+6u/5r8zD+udQO/tqIBDUACHiEIEKdrACOEBR5vYHSv+cK6+24zrf94A24AziBO1wBGCAtoAALE6RrACGEBDUCAOH1N7x6+C2HmWcAZSB79SAN95tlRA8mjH2mgzzw7aiB59CPfhfrMs6MzkDz6kQb6zLOjBpJHP9JAn3l21EDy6EcfG0kbmWsMNT0AAAAASUVORK5CYII="
                    id="a"
                    width="48"
                    height="48"
                />
                <path
                    id="b"
                    d="M18,0 L124,0 C133.941125,-3.55271368e-15 142,8.0588745 142,18 C142,27.9411255 133.941125,36 124,36 L18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z"
                />
            </defs>
            <g fill="none" fillRule="evenodd" transform="translate(1 1)">
                <path
                    fill="#F6F6F0"
                    stroke="#B0AEAE"
                    d="M993.5,4 L993.5,352 C993.5,354.485281 991.485281,356.5 989,356.5 L4,356.5 C1.51471863,356.5 -0.5,354.485281 -0.5,352 L-0.5,4 C-0.5,1.68589182 1.25464618,-0.244648316 3.56580731,-0.478711388 L4.00000066,-0.499999495 L989,-0.5 C991.485281,-0.5 993.5,1.51471863 993.5,4 Z"
                />
                <g transform="translate(16 24)">
                    <g transform="translate(244)">
                        <g transform="translate(0 280)">
                            <use xlinkHref="#b" fill="#00214A" />
                            <text fill="#FFF" fontFamily="TVNordEF-BlackCon" fontSize="16">
                                <tspan x="20.408" y="23">
                                    Button : Medium
                                </tspan>
                            </text>
                        </g>
                        <text fill="#3B3B3B" fontFamily="Adelle-Regular, Adelle" fontSize="16">
                            <tspan x="0" y="60">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque a nisi eu eros
                                mattis{" "}
                            </tspan>
                            <tspan x="0" y="85">
                                suscipit. Etiam non mollis libero. Ut eu dui sed metus maximus varius a at nibh.
                                Phasellus{" "}
                            </tspan>
                            <tspan x="0" y="110">
                                blandit, tortor eu bibendum fringilla, augue diam elementum est, nec sodales erat enim
                                eget{" "}
                            </tspan>
                            <tspan x="0" y="135">
                                magna. Donec vestibulum sapien ac velit pretium tincidunt. Proin sit amet dui vitae nibh
                                rutrum{" "}
                            </tspan>
                            <tspan x="0" y="160">
                                mattis. Cras lacus nisi, feugiat a sapien at, fringilla condimentum lorem.
                            </tspan>
                            <tspan x="0" y="201">
                                Vivamus bibendum tellus a consequat molestie. Vestibulum laoreet enim a velit efficitur{" "}
                            </tspan>
                            <tspan x="0" y="226">
                                tincidunt. Nulla varius libero in ultrices blandit. Suspendisse lobortis dignissim
                                tincidunt. Nunc{" "}
                            </tspan>
                            <tspan x="0" y="251">
                                iaculis mi non facilisis eleifend. Morbi sodales vulputate condimentum.{" "}
                            </tspan>
                        </text>
                        <text fill="#0C0908" fontFamily="TVNordEF-BlackCon" fontSize="28">
                            <tspan x="0" y="25">
                                {"{H3/H4/H5/H6 : Headline Title}"}
                            </tspan>
                        </text>
                    </g>
                    <rect width="228" height="228" fill="url(#c)" />
                </g>
                <rect width="993" height="8" fill="#00214A" />
            </g>
        </svg>
    );
};

export default React.memo(IconCallOutLarge);
